import { apiUtils } from './apiUtils';

class ProfileAPI {
  async getProfile() {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getEmployeeRoleHistory(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeRoleHistory?EmployeeUsername=${data.username}`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getProfileAsAdmin(props) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeInfo`,
      params: props
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getProfileUserData(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeUserData?Username=${data.username}`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async saveProfileUserData(data) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/SaveUserData`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getOptions() {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeTypes`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async GetEmployeeAcceptances(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeAcceptances?type=${data.type}`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async SaveEmployeeAcceptances(props) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/SaveEmployeeAcceptances`,
      params: props
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async GetEmployeesPhotos(usernames) {
    usernames = usernames ? `?Usernames=${usernames}` : '';
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeesPhotos${usernames}`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async saveEmployeeInfo(data) {
    const input = {};
    input.EmployeeInfo = { ...data };
    input.EmployeeInfo.incomeHolderID = data.incomeHolderID && data.incomeHolderID.value ? data.incomeHolderID.value : data.incomeHolderID;
    input.EmployeeInfo.maritialStatus = data.maritialStatus && data.maritialStatus.value ? data.maritialStatus.value : data.maritialStatus;
    input.EmployeeInfo.category = data.category && data.category.value ? data.category.value : data.category;
    input.EmployeeInfo.contractTypeID = data.contractTypeID && data.contractTypeID.value ? data.contractTypeID.value : data.contractTypeID;
    input.EmployeeInfo.department = data.department && data.department.value ? data.department.value : data.department;
    input.EmployeeInfo.departmentRoleID = data.departmentRoleID && data.departmentRoleID.value ? data.departmentRoleID.value : data.departmentRoleID;
    input.EmployeeInfo.employee_SYS_STATUS_ID = data.employee_SYS_STATUS_ID && data.employee_SYS_STATUS_ID.value ? data.employee_SYS_STATUS_ID.value : data.employee_SYS_STATUS_ID;
    input.EmployeeInfo.deliveryCenterTypeID = data.deliveryCenterTypeID && data.deliveryCenterTypeID.value ? data.deliveryCenterTypeID.value : 0;
    input.EmployeeInfo.countryID = data.countryID && data.countryID.value ? data.countryID.value : 0;
    input.EmployeeInfo.billingClassID = data.billingClassID && data.billingClassID.length > 0 ? data.billingClassID.map(item => item.value).join(',') : 0;
    input.EmployeeInfo.genderID = data.genderID && data.genderID.value ? data.genderID.value : 0;
    input.EmployeeInfo.nationalityID = data.nationalityID ? data.nationalityID.map(item => item.value).join(',') : null;
    input.EmployeeInfo.birthCountryID = data.birthCountryID && data.birthCountryID.value ? data.birthCountryID.value : null;
    input.EmployeeInfo.mainLanguageID = data.mainLanguageID && data.mainLanguageID.value ? data.mainLanguageID.value : null;
    input.EmployeeInfo.documentTypeID = data.documentTypeID && data.documentTypeID.value ? data.documentTypeID.value : 0;
    input.EmployeeInfo.professionalOrderID = data.professionalOrderID && data.professionalOrderID.value ? data.professionalOrderID.value : null;
    // input.EmployeeInfo.disabilityFile = data.disability?.document ? data.disability?.document : null;
    input.EmployeeInfo.dependentsDisabilityFile = data.disabilityDependents?.document ? data.disabilityDependents?.document : null;

    input.academicQualifications = data.academicQualifications.map(q => {
      return { ...q, academicDegree: q.academicDegree && q.academicDegree.value ? q.academicDegree.value : q.academicDegree }
    });
    input.certifications = data.certifications.map(q => {
      return {
        ...q,
        // certificationID: q.certificationID && q.certificationID.value ? q.certificationID.value : q.certificationID,
        certificatorID: q.certificatorID && q.certificatorID.value ? q.certificatorID.value : q.certificatorID,
      }
    });

    input.professionalData = data.professionalData;
    input.personalDocuments = data.personalDocuments;
    input.languages = data.languages;
    input.employeeDependents = data.dependentsData;
    input.employeeEmergencyContacts = data.emergencyContacts;

    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/SaveEmployeeInfo`,
      params: input
    };
    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async saveEmployeeInfoAsAdmin(data) {
    const input = {};
    input.EmployeeInfo = { ...data };
    input.EmployeeInfo.incomeHolderID = data.incomeHolderID && data.incomeHolderID.value ? data.incomeHolderID.value : data.incomeHolderID;
    input.EmployeeInfo.maritialStatus = data.maritialStatus && data.maritialStatus.value ? data.maritialStatus.value : data.maritialStatus;
    input.EmployeeInfo.category = data.category && data.category.value ? data.category.value : data.category;
    input.EmployeeInfo.contractTypeID = data.contractTypeID && data.contractTypeID.value ? data.contractTypeID.value : data.contractTypeID;
    input.EmployeeInfo.department = data.department && data.department.value ? data.department.value : data.department;
    input.EmployeeInfo.departmentRoleID = data.departmentRoleID && data.departmentRoleID.value ? data.departmentRoleID.value : data.departmentRoleID;
    input.EmployeeInfo.employee_SYS_STATUS_ID = data.employee_SYS_STATUS_ID && data.employee_SYS_STATUS_ID.value ? data.employee_SYS_STATUS_ID.value : data.employee_SYS_STATUS_ID;
    input.EmployeeInfo.deliveryCenterTypeID = data.deliveryCenterTypeID && data.deliveryCenterTypeID.value ? data.deliveryCenterTypeID.value : 0;
    input.EmployeeInfo.countryID = data.countryID && data.countryID.value ? data.countryID.value : 0;
    input.EmployeeInfo.billingClassID = data.billingClassID && data.billingClassID.length > 0 ? data.billingClassID.map(item => item.value).join(',') : 0;
    input.EmployeeInfo.genderID = data.genderID && data.genderID.value ? data.genderID.value : 0;
    input.EmployeeInfo.nationalityID = data.nationalityID ? data.nationalityID.map(item => item.value).join(',') : null;
    input.EmployeeInfo.birthCountryID = data.birthCountryID && data.birthCountryID.value ? data.birthCountryID.value : null;
    input.EmployeeInfo.mainLanguageID = data.mainLanguageID && data.mainLanguageID.value ? data.mainLanguageID.value : null;
    input.EmployeeInfo.documentTypeID = data.documentTypeID && data.documentTypeID.value ? data.documentTypeID.value : 0;
    input.EmployeeInfo.professionalOrderID = data.professionalOrderID && data.professionalOrderID.value ? data.professionalOrderID.value : null;
    input.EmployeeInfo.dependentsDisabilityFile = data.disabilityDependents?.document ? data.disabilityDependents?.document : null;

    if (data.newRoleStartDate !== null) { input.newRoleStartDate = data.newRoleStartDate; }

    input.academicQualifications = data.academicQualifications?.map(q => {
      return { ...q, academicDegree: q.academicDegree && q.academicDegree.value ? q.academicDegree.value : q.academicDegree }
    });
    input.certifications = data.certifications?.map(q => {
      return {
        ...q,
        // certificationID: q.certificationID && q.certificationID.value ? q.certificationID.value : q.certificationID,
        certificatorID: q.certificatorID && q.certificatorID.value ? q.certificatorID.value : q.certificatorID,
      }
    });

    input.professionalData = data.professionalData;
    input.personalDocuments = data.personalDocuments;
    input.languages = data.languages;
    input.employeeDependents = data.dependentsData;
    input.employeeEmergencyContacts = data.emergencyContacts;

    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/SaveEmployeeInfoAsAdmin`,
      params: input
    };
    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async GetEmployeeCVData(params) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeCVData`,
      params: params
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getInfoInactiveUser(username) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeDeparture?EmployeeUsername=${username}`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async saveInfoInactiveUser(data) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/SaveEmployeeDeparture`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getEmployeeDependentsDocument(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Employee/GetEmployeeDependentDocuments?Username=${data?.username}&DocumentType=${data?.documentType}&DocumentID=${data?.documentID}`,
    };

    const response = await apiUtils.handleDownloadMethod(Input);
    return response;
  }

  async saveEmployeeChilds(data) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeChilds/${data.username}`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async getEmployeeChilds(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeChilds/${data.username}`,
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async getEmployeeEmergencyContact(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeEmergencyContacts/${data.username}`,
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async saveEmployeeEmergencyContact(data) {
    const input = { ...data };
    input.genderID = data.genderID && data.genderID.value ? data.genderID.value : 0;
    input.kinshipID = data.kinshipID && data.kinshipID.value ? data.kinshipID.value : 0;

    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeEmergencyContacts/${data.username}`,
      params: input
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async saveEmployeeDocuments(data) {
    const input = { ...data };
    input.document = data?.files?.document;
    input.documentTypeID = data.documentType && data.documentType.value ? data.documentType.value : 0;

    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeDocuments/${data?.username}`,
      params: input
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async getEmployeeDocuments(username) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeDocuments/${username}`,
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async downloadEmployeeDocument(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeDocuments/DownloadEmployeeDocument/${data?.documentID}/${data?.username}`,
    };

    const response = await apiUtils.handleDownloadMethod(Input);
    return response;
  }

  async getEmployeeEvaluators(data) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeEvaluators/${data.evaluated}${data.year ? `?year=${data.year}` : ''}`,
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async saveEmployeeEvaluators(data) {
    const input = {
      year: data.year ? Number(data.year) : null,
      employeeEvaluators: data.employeeSGD.map((field) => {
        return {
          evaluated: data?.evaluated ?? null,
          evaluator: field.evaluator && field.evaluator.text ? field.evaluator.text : null,
        }
      })
    }
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeEvaluators/${data.evaluated}`,
      params: input
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async getEmployeeCompensationsBenefits(username) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeCompensationBenefits/${username}`,
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async saveEmployeeCompensationsBenefits(data) {
    data.remunerationID = data.remuneration && data.remuneration.value ? data.remuneration.value : 0;
    data.remunerationFrequencyID = data.remunerationFrequency && data.remunerationFrequency.value ? data.remunerationFrequency.value : 0;
    data.remunerationTypeID = data.remunerationType && data.remunerationType.value ? data.remunerationType.value : 0;
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeCompensationBenefits/${data.username}`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getEmployeeVirtualCards(username) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeVirtualCards/${username}`,
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async saveEmployeeVirtualCards(data) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeVirtualCards/${data.username}`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async getProfileSkill(skillParent, username) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeSkills/${username}?skillParent=${skillParent}`
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async saveProfileSkill(data) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeSkills/${data.username}`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async getEmployeeHistoryData(username) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmploymentRelationship/${username}`,
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async saveEmployeeHistoryData(data) {
    const input = { ...data }
    input.areaDepartmentID = data.areaDepartmentID && data.areaDepartmentID.value ? data.areaDepartmentID.value : 0;
    input.categoryID = data.categoryID && data.categoryID.value ? data.categoryID.value : 0;
    input.contractTypeID = data.contractTypeID && data.contractTypeID.value ? data.contractTypeID.value : 0;
    input.employeeTypeID = data.employeeTypeID && data.employeeTypeID.value ? data.employeeTypeID.value : 0;
    input.employeeAreaID = data.employeeAreaID && data.employeeAreaID.value ? data.employeeAreaID.value : 0;
    input.groupDirectionID = data.groupDirectionID && data.groupDirectionID.value ? data.groupDirectionID.value : 0;
    input.levelYearID = data.levelYearID && data.levelYearID.value ? data.levelYearID.value : 0;
    input.leverageID = data.leverageID && data.leverageID.value ? data.leverageID.value : 0;
    input.officeID = data.officeID && data.officeID.value ? data.officeID.value : 0;
    input.officeLocationID = data.officeLocationID && data.officeLocationID.value ? data.officeLocationID.value : 0;
    input.provisionModeID = data.provisionModeID && data.provisionModeID.value ? data.provisionModeID.value : null;
    input.regimeID = data.regimeID && data.regimeID.value ? data.regimeID.value : null;
    input.roleID = data.roleID && data.roleID.value ? data.roleID.value : 0;
    input.echelonID = data.echelonID && data.echelonID.value ? data.echelonID.value : 0;
    input.partnerTypeID = data.partnerTypeID && data.partnerTypeID.value ? data.partnerTypeID.value : null;
    input.remuneration = data.remuneration
    input.benefits = data.benefits

    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmploymentRelationship/${data.username}`,
      params: input,
      timeout: 60000
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async getEmployeeVacationModifiedHistory(username) {
    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeVacationManagement/GetEmployeeVacationManagementHistory/${username}`
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }

  async saveEmployeeVacationManagementHistory(data) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/EmployeeVacationManagement/SaveEmployeeVacationManagementHistory`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);
    return response;
  }
}

export const profileAPI = new ProfileAPI();
